import React from 'react'

export default function GuideMap() {
    return (
        <div>GuideMap</div>
    )
}
